import React from 'react';

import { RHP } from 'providers';
import { useStartupCXI } from 'modules/startup/_startupId/cxi/useStartupCXI';
import * as Styled from './StyledMatchConnection';

export const MatchConnectionMessage = ({ match }) => {
    const { t, vars } = useStartupCXI();
    const { startupId } = vars;

    const handleClick = () => {
        RHP.push(`/startup/${startupId}/100-10-1/messages/${match.matchId}`);
    };

    return (
        <Styled.MatchConnection className="chat" onClick={handleClick}>
            <span className="icon far fa-fw fa-comments-alt" aria-hidden="true" />
            <span className="text">{t('match.connection.message')}</span>
        </Styled.MatchConnection>
    );
};
